import { Logger } from 'ui-common/src';
import { removeMenuById, removeMenuByIds } from '../utils/removeMenuByID/removeMenuByID';

export const SIDE_MENU_LOADING = 'SIDE_MENU_LOADING';
export const SIDE_MENU_LOADED = 'SIDE_MENU_LOADED';
export const UPDATE_MENU_FILTER = 'UPDATE_MENU_FILTER';

const sideMenuLoading = () => ({ type: SIDE_MENU_LOADING, loading: true });

const InitializeSideMenu = (featureFlags, leftMenuData) => (dispatch, getState) => {
  dispatch(sideMenuLoading());

  const MENU_TO_ALLOW_IF_PAM_DISABLED = [
    'new-privileged-access',
    'privileged-sessions',
    'past-sessions',
  ];
  const { isPamGen2, isEmergencyRolesUser, isIntegration, isPamAdminAccount } = featureFlags;

  Logger.info(leftMenuData);

  if (leftMenuData && leftMenuData.length > 0) {
    let sideMenu = [
      ...leftMenuData.filter((menu) => menu.id !== (isIntegration ? 'design' : 'integrations')),
    ];
    Logger.info(sideMenu);

    if (isPamGen2) {
      sideMenu = removeMenuByIds(sideMenu, MENU_TO_ALLOW_IF_PAM_DISABLED);
    }
    if (!isEmergencyRolesUser) {
      sideMenu = removeMenuById(sideMenu, 'request-emergency-access-roles');
    }
    if (!isPamAdminAccount) {
      // Change manage-pam to manage-jita
      sideMenu = sideMenu.map(menu => {
        if (menu.id === 'control-centre' && menu.subMenu) {
          return {
            ...menu,
            subMenu: menu.subMenu.map(subItem => 
              subItem.id === 'sessions' 
                ? { ...subItem, id: 'jita-sessions' }
                : subItem
            )
          };
        }
        return menu;
      });
    }

    Logger.info(sideMenu);

    dispatch({
      type: SIDE_MENU_LOADED,
      data: sideMenu,
    });
  }
};

const updateMenuFilter = (menuId, isEnabled) => (dispatch, getState) => {
  const state = getState();
  const currentFilter = state.app?.menuFilters?.[menuId];
  const rawSideMenu = state.app?.rawSideMenu;
  
  // Only update if conditions are met
  if (rawSideMenu?.length && currentFilter !== isEnabled) {
    dispatch({
      type: UPDATE_MENU_FILTER,
      menuId,
      isEnabled
    });
  }
};

export { InitializeSideMenu, updateMenuFilter };
